import { render, staticRenderFns } from "./blank-summary.vue?vue&type=template&id=181ce492&"
import script from "./blank-summary.vue?vue&type=script&lang=js&"
export * from "./blank-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports